import React from 'react';
import styles from './BookingReferenceSearchPanel.module.css';

var initialState = {
    account: '',
    reference: ''
};

export default class BookingReferenceSearchPanel extends React.Component {

    constructor(props) {
        super(props);

        if (props.defaultAccount) {
            Object.assign(initialState, {
                account: props.defaultAccount
            })
        }

        this.state = initialState;

        this.resetForm = this.resetForm.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    resetForm() {

        if (this.props.defaultAccount) {
            Object.assign(initialState, {
                account: this.props.defaultAccount
            })
        }

        this.setState(initialState);
    }

    handleChange(event) {

        this.setState({
            [event.target.name]: (event.target.type === 'checkbox') ? event.target.checked: event.target.value
        })

    }

    handleSubmit(event) {
        event.preventDefault();

        const formData = new FormData(document.getElementById('bookingReferenceQueryForm'));
        this.props.onFormSubmit(formData);
    }

    render() {

        var accountOptions = null;

        if (this.props.accountOptions !== undefined && this.props.accountOptions !== null) {
            var sortedAccounts = _.sortBy(this.props.accountOptions, ['label']);
            accountOptions = sortedAccounts.map(
                (a) => <option key={a.value} value={a.value}>{a.label}</option>
                );
        }

        return (
            <div id="bookingReferenceSearchParnel">
                <form id="bookingReferenceQueryForm" styleName="styles.form" onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10">
                            <div className="row">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4">
                                    <div className="form-group">
                                        <label>Account</label>
                                        <select className="form-control" name="account" value={this.state.account} onChange={this.handleChange}>
                                            {accountOptions}
                                        </select>
                                        
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-2">
                                    <div className="form-group">
                                        <label>Reference</label>
                                        <input className="form-control" type="text" name="reference" value={this.state.reference} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2">
                            <div styleName="styles.padding-label" />
                            <button type="submit" className="btn btn-default btn-dl-green">FIND</button>
                            <button type="button" className="btn btn-default btn-dl-green" onClick={this.resetForm}>CLEAR</button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}